import { createAction, createSlice, PayloadAction } from "@reduxjs/toolkit";

const clearAction = createAction("clear");

export type BackgroundTaskKind =
  | "certificate"
  | "worker_csv"
  | "batch_document"
  | "batch_upload";

export interface BackgroundTask {
  id: string;
  description: string;
  status: "in_progress" | "completed" | "failed";
  isWatcher?: boolean;
  kind?: BackgroundTaskKind;
  companySubjectId?: string;
  startedAt?: string;
}

interface BackgroundTasksState {
  tasks: BackgroundTask[];
}

const initialState: BackgroundTasksState = {
  tasks: [],
};

export const backgroundTasksSlice = createSlice({
  name: "backgroundTasks",
  initialState,
  reducers: {
    setBackgroundTask: (
      state,
      action: PayloadAction<Omit<BackgroundTask, "status"> & { status?: BackgroundTask["status"] }>,
    ) => {
      if (!state.tasks.some((task) => task.id === action.payload.id)) {
        state.tasks.push({ ...action.payload, status: action.payload.status || "in_progress" });
      }
    },
    removeBackgroundTask: (state, action: PayloadAction<string>) => {
      state.tasks = state.tasks.filter((task) => task.id !== action.payload);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(clearAction, () => initialState);
  },
});

export const { setBackgroundTask, removeBackgroundTask } = backgroundTasksSlice.actions;

export default backgroundTasksSlice.reducer;
